module.exports = __webpack_public_path__ + "img/接口.9047d5b5.svg";